export const physicalToLogicalAlignmentLTRMap = {
    left: 'start',
    center: 'center',
    right: 'end',
};
const physicalToLogicalAlignmentRTLMap = {
    right: 'start',
    center: 'center',
    left: 'end',
};
export const convertPhysicalAlignmentToLogical = (physicalAlignment, direction = 'ltr') => direction === 'rtl'
    ? physicalToLogicalAlignmentRTLMap[physicalAlignment]
    : physicalToLogicalAlignmentLTRMap[physicalAlignment];
const logicalToPhysicalAlignmentLTRMap = {
    start: 'left',
    center: 'center',
    end: 'right',
};
const logicalToPhysicalAlignmentRTLMap = {
    start: 'right',
    center: 'center',
    end: 'left',
};
export const convertLogicalAlignmentToPhysical = (logicalAlignment, direction = 'ltr') => direction === 'rtl'
    ? logicalToPhysicalAlignmentRTLMap[logicalAlignment]
    : logicalToPhysicalAlignmentLTRMap[logicalAlignment];
export const castToInheritIfNeeded = (value, parentValue) => (value === parentValue ? 'inherit' : value);
export const castFromInheritIfNeeded = (value, parentValue) => (!value || value === 'inherit' ? parentValue : value);
export const resolveInheritanceChain = (valueHierarchy, ultimateParentValue) => {
    for (const currentValue of valueHierarchy) {
        if (currentValue && currentValue !== 'inherit') {
            return currentValue; // We've checked it's not 'inherit', so it must be V
        }
    }
    return ultimateParentValue;
};
export const getOppositeAlign = (align) => align === 'start' ? 'end' : 'start';
//# sourceMappingURL=utils.js.map